<dx-load-panel
    [shadingColor]="'rgba(0,0,0,0.4)'"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
>
</dx-load-panel>
<div *ngFor="let result of results">
    <div style="text-align: center; background-color: rgba(255,157,9,0.32); height: 24px;">
        <h5 style="height: 24px; margin: 10px !important;">{{ result.name }} {{ isCancelled ? '- CANCELED' : result.results?.length === 0 ? '- ' + result.status : ''}}</h5>
    </div>
    <div *ngFor="let pathologyResult of result.results; trackBy: forTracker">
        <div style="text-align: center; background-color: rgba(191, 191, 191, 0.15); height: 24px;">
            <h5 style="height: 24px; margin-top: 0 !important;">{{ pathologyResult.title }}</h5>
        </div>
        <p disabled="true" [innerHtml]="pathologyResult.comment" style="border: 0; padding: 20px; overflow-x: auto"></p>
    </div>
</div>
